import React, { useEffect, useState } from "react";
import { companyProfile } from "../../../../api/Dtos/profileDto";
import { useNavigate } from "react-router-dom";
import { useToaster } from "../../../../Toaster/Toaster";
import { mtCountryDto } from "../../../../api/interfaces/addUser";
import { getService, postService } from "../../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../../api";
import { SubmitHandler, useForm } from "react-hook-form";
import { useLoader } from "../../../../Loader/LoaderContext";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import DynamicTextPopup from "../../../Portals/Modals/dynamicTextPopup";
import DynamicSuccessPopup from "../../../Portals/Modals/DynamicSuccessPopup";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
function CompanyProfile() {
   const [isApprove,setIsApprove]=useState(false);
  const [isOpen, setOpen] = useState(false)
  const [formData, setFormData] = useState<companyProfile>();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const router = useNavigate()
  const [selectedFiles, setSelectedFiles] = useState<string[]>([]);
  const [files, setFiles] = useState<(File | null)[]>([]);
  const today = new Date().toISOString().split("T")[0];
  const [expanded, setExpanded] = useState<string | false>(false);
  const [events, setEvents] = useState<any[]>([]);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [file, setFile] = useState<string | null>(null);
  const { showToast } = useToaster();
  const leadId =localStorage.getItem('leadId');
  const [submittedData, setSubmittedData] = useState<any | null>(null);
  const [mtContryData, setMtCountry] = useState<mtCountryDto[]>([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [phoneCode, setPhonecode] = useState({ isoCode: "", code: "" });
  const handleFileChanges = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const file = event.target.files?.[0];
    const allowedTypes = ["image/png", "image/jpeg"];
    const maxSizeInMB = 3;

    if (file) {
      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        alert("Please select a valid image (PNG or JPG).");
        return;
      }

      // Validate file size
      if (file.size > maxSizeInMB * 1024 * 1024) {
        alert(`File size should not exceed ${maxSizeInMB} MB.`);
        return;
      }

      // Create a file URL
      const fileUrl = URL.createObjectURL(file);

      // Update the file array
      setFiles((prevFiles) => {
        const updatedFiles = [...prevFiles];
        updatedFiles[index] = file; // Assign the file at the given index
        return updatedFiles;
      });

      // Update the preview URL array
      setSelectedFiles((prevUrls) => {
        const updatedUrls = [...prevUrls];
        updatedUrls[index] = fileUrl; // Assign the URL at the given index
        return updatedUrls;
      });
    }
  };
  const draft=()=>{
    setIsApprove(false)
  }
  const approve=()=>{
    setIsApprove(true);
  }
  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setSelectedFile(selectedFile);
      // setValue('imageDto',selectedFile)
      // Convert the file to a Base64 string
      const preview = await convertToBase64(selectedFile);
      setFile(preview);
    }
  };
  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCountryId = e.target.value;
    setSelectedCountry(selectedCountryId);

    const selectedCountry = mtContryData.find(
      (country: any) => country.id == selectedCountryId
    );
    if (selectedCountry) {
      setPhonecode((prev) => {
        const updatedPhoneCode = {
          isoCode: selectedCountry.isoCode,
          code: selectedCountry.code,
        };
        return updatedPhoneCode;
      });
      console.log(phoneCode);
    }
  };
  const mtCountryDtoData = async () => {
    setLoading(true);
    try {
      const response = await getService(API_ENDPOINTS.countryData);
      console.log(response);
      setMtCountry(response.data);
      return response.data;
      setTimeout(() => {
        setLoading(false)
      }, 1000);
    } catch (error) {
      setTimeout(() => {
        setLoading(false)
      }, 1000);
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false)
      }, 1000);
    }
  };
  const handleAddEvent = () => {
    const newEventId = events.length + 1;
    setEvents([
      ...events,
      {
        id: newEventId,
        name: `Event ${newEventId}`,
        startDate: "",
        endDate: "",
        contactPersonName: "",
        contactPersonEmail: "",
        phoneNo: "",
        mtCountryDto: {
          id: null,
          name: "",
          code: "",
          isoCode: "",
        }, // Default mtCountryDto object
        venue: "",
        link: "",
        type: "",
        imageDto: {
          name: "",
          base64Str: "",
          type: "",
          documentUrl: "",
        },
      },
    ]);
    setExpanded(`panel${newEventId}`);
  };
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    getValues, trigger,
    formState: { errors, isDirty },
  } = useForm<companyProfile>({
    mode: "onChange", // This allows validation checks to trigger as the user types.
  });
  const { setLoading } = useLoader();
  useEffect(() => {
    mtCountryDtoData();
    fetchDetails();
  }, []);

  const fetchDetails = async () => {
    try {
      let url: string;
      const countryData = await mtCountryDtoData();
      const response = await getService(API_ENDPOINTS.getCompanyProfile+"?leadId="+leadId); // Fetch post details using 'id'
      setSubmittedData(response.data);
      const res = response.data;
      setEvents(response.data.authorDtos)
      // localStorage.setItem('userName',res.firstName  +" "+ res.lastName);

      setSelectedCountry(response.data?.mtCountryDto?.id);
      const selectedIsoCode = response.data?.mtCountryDto?.id;
      const selectedCountry = countryData.find(
        (country: any) => country.id === selectedIsoCode
      );
      if (selectedCountry) {
        setPhonecode({
          isoCode: selectedCountry.isoCode,
          code: selectedCountry.code,
        });
        setValue("phoneisoCode", selectedIsoCode);
      }else{
        const selectedCountry = countryData.find(
          (country: any) => country.id == "1"
        );
        setPhonecode({
          isoCode: selectedCountry.isoCode,
          code: selectedCountry.code,
        });
        setValue("phoneisoCode", selectedIsoCode);
       }
      reset({
        ...response.data, // Resetting other data from the response
      })
      setTimeout(() => {
        setLoading(false); // Stop loader after 500ms
        //   setIsLoading(false); // Stop local loading
      }, 500);
    } catch (error) {
      console.error("Error fetching post details:", error);
      setTimeout(() => {
        setLoading(false); // Stop loader in case of error
        //   setIsLoading(false);
      }, 500);
    }
  };


  const phoneNuberChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIsoCode = e.target.value;
    console.log("Selected ISO Code:", selectedIsoCode);

    const selectedCountry = mtContryData.find(
      (country: any) => country.isoCode === selectedIsoCode
    );

    if (selectedCountry) {
      setPhonecode({
        isoCode: selectedCountry.isoCode,
        code: selectedCountry.code,
      });
      console.log("Updated Phone Code:", {
        isoCode: selectedCountry.isoCode,
        code: selectedCountry.code,
      });
      //   setValue("phoneNo", "");
    }
  };
  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };
  const onFormSubmit: SubmitHandler<companyProfile> = async (data) => {
    setFormData(data);
    setShowConfirmation(true)

  }
  const closePopup = () => {
    setOpen(false);
    router('/vendorDashboard/activateDashbord/companyViewProfile')
  }
  const handleClosePopup = () => setShowConfirmation(false);
  const saveData = async () => {
    setLoading(true);
    const updatedLeaderShipTeamDtos = await Promise.all(
      (formData?.authorDtos ?? [])?.map(async (team, index) => {
        if (files[index]) {
          const base64Str = await convertFileToBase64(files[index] as File);
          const name = (files[index] as File).name;
          const type = (files[index] as File).type;

          return {
            ...team,
            imageDto: {
              base64Str: base64Str,
              name,
              type,
            },
          };
        }
        return team; // Return unchanged object if no file is uploaded
      })
    );
    try {
      let payload = {
        // ...submittedData,

        name: formData?.name,
        email: formData?.email,
        type: formData?.type,
        contactPersonName: formData?.contactPersonName,
        phoneNo: formData?.phoneNo,
        companyInfo: formData?.companyInfo,
        streetAddress: formData?.streetAddress,
        apartment: formData?.apartment,
        imageDto: selectedFile
          ? {
            name: selectedFile?.name,
            type: selectedFile?.type,
            base64Str: file,
          }
          : formData?.imageDto?.documentUrl
            ? { ...formData.imageDto } // If existing image, retain it
            : null,
        street: formData?.streetAddress,
        state: formData?.state,
        postalCode: formData?.postalCode,
        mtCountryDto: formData?.mtCountryDto?.id ? {
          id: parseInt(formData?.mtCountryDto?.id as unknown as string, 10),
        } : formData?.mtCountryDto ? {
          id: parseInt(formData?.mtCountryDto as unknown as string, 10),
        } : null,
        city: formData?.city,
        authorDtos: updatedLeaderShipTeamDtos,
        leadId:leadId,
      }
      if (isApprove) {
        (payload as any).profilingStatus = 'PUBLISHED';
      }
      const response = await postService(API_ENDPOINTS.saveCompanyProfile, payload);
      if (response) {
        setSelectedCountry("");
        // onSave()
        handleClosePopup();
        setOpen(true);
        // showToast('Profile updated successfully!', 'success', "");

      }
    } catch (error: any) {
      // setApiError(error.response?.data?.message);
      console.error('Login error:', error);
      if (error.response?.data?.message === 'Invalid Otp. Please try again.') {

      }
    }
    finally {
      setLoading(false);
    }

  }
const back=()=>{
  router('/vendorDashboard/activateDashbord/companyViewProfile')
}

  return (
    <div className='mb-5 p-6 pl-12'>
      <h3 className='text-gray-900 font-bold text-3xl mb-5 flex items-center mt-2'>  <span><img src='/images/back.svg' className="mr-2 cursor-pointer" onClick={back} /></span> Company  Details
      
      </h3>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <div className=' rounded-lg mt-5'>
          <div className='bg-white p-8'>
            <div className='w-[75%]'>
              <h3 className='text-gray-900 font-bold text-xl'> Basic details</h3>
              <div className='flex items-center py-3 mt-4'>
                <img src={
                  file
                    ? (file as string)
                    : selectedFile
                      ? URL.createObjectURL(selectedFile)
                      : submittedData?.imageDto?.documentUrl || '/images/userImg.svg'
                }
                  alt="Preview" className='w-[80px] h-[80px] mr-3 rounded-full' />
                <div>
                  <p className="font-semibold text-gray-900 text-base font-sans mb-0">
                    Upload Company Photo
                  </p>
                  <p className="text-sm font-normal text-gray-500 mt-1 font-sans mb-3">
                    Photo should be atleast in 150px X 150px
                  </p>
                  <label className=' mt-2 px-4 border border-[#D1D5DB] text-[#374151] font-medium text-sm rounded-md p-2 cursor-pointer'>
                    Upload new photo
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      className="hidden"
                    />
                  </label>
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4 mt-2">

                <div className="form-group">
                  <label
                    htmlFor="username"
                    className="block text-[#374151] font-semibold text-sm font-sans"
                  >
                    Company Name
                  </label>
                  <div className="input-group mt-2">
                    <input
                      {...register("name", {
                        required: 'Name is required',
                      })}
                      type="text"
                      placeholder="Enter Company Name"

                      className="form-control font-normal font-Inter text-base text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                    />
                  {errors.name && (
                <p className="text-primary-color text-sm mt-1">{errors.name.message}</p>
              )}
                  </div>
                </div>


              </div>
              <div className='grid grid-cols-2 mt-4 mb-2 gap-7'>
                <div className="form-group">
                  <label
                    htmlFor="username"
                    className="block text-[#374151] font-semibold text-sm font-sans"
                  >
                    Company Type
                  </label>
                  <div className="input-group mt-2">
                    <input
                      {...register("type", {
                        // required: 'Name is required',
                      })}
                      type="text"
                      placeholder="Enter Company Name"

                      className="form-control font-normal font-Inter text-base text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                    />

                  </div>
                </div>
                <div className="form-group">
                  <label
                    htmlFor="username"
                    className="block text-[#374151] font-semibold text-sm font-sans"
                  >
                    Contact Person Name
                  </label>
                  <div className="input-group mb-2 mt-2">
                    <input
                      {...register("contactPersonName", {
                        // required: 'firstName is required',
                      })}
                      type="text"
                      placeholder="Enter Contact Person Name"

                      className="form-control font-normal font-Inter text-base text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                    />
                    {/* {errors.firstName && (
                <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
              )} */}
                  </div>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-7 mb-2 mt-2">

                <div className="form-group">
                  <label
                    htmlFor="username"
                    className="block text-[#374151] font-semibold text-sm font-sans"
                  >
                    Email
                  </label>
                  <div className="input-group mb-3 mt-2">
                    <input
                      {...register("email", {
                        // required: 'firstName is required',
                      })}
                      disabled
                      type="email"
                      placeholder="Enter your Email"

                      className="form-control font-normal font-Inter text-base text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                    />
                    {/* {errors.firstName && (
                <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
              )} */}
                  </div>
                </div>
                <div className="form-group">
                  <label
                    htmlFor="username"
                    className="block text-[#374151] font-semibold text-sm font-sans"
                  >
                    Phone Number
                  </label>
                  <div className=" form-group mb-4 sm:mb-0">
                    <div className="flex border border-gray-300 rounded mt-1 form-controls">
                      <select
                        value={phoneCode.isoCode || ""}
                        {...register("phoneisoCode")}
                        onChange={(e) => phoneNuberChange(e)}
                        className="border-none bg-white pl-3 py-2 text-sm font-semibold text-gray-700 focus:outline-none"
                      >
                        {mtContryData.map((item: any) => (
                          <option key={item.id} value={item.isoCode || ""}>
                            {item.isoCode}
                          </option>
                        ))}
                      </select>
                      <input
                        type="text"
                        placeholder="Enter your phone number"
                        {...register("phoneNo")}
                        onInput={(e) => {
                          e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, "");
                        }}
                        className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                      />
                    </div>

                   
                  </div>
                </div>

              </div>
              <div className="grid grid-cols-1 gap-4 mt-2">

                <div className="form-group">
                  <label
                    htmlFor="username"
                    className="block text-[#374151] font-semibold text-sm font-sans"
                  >
                    Company Info
                  </label>
                  <div className="input-group mb-3 mt-2">
                    <textarea
                      rows={4}
                      placeholder="Enter Company Info"
                      {...register("companyInfo", {
                        maxLength: {
                          value: 1500,
                          message: "Company information cannot exceed 1500 characters. Please shorten your text.",
                        },

                      })}
                      className="w-full border font-normal font-Inter text-base text-[#6B7280] p-2 rounded-md"
                    />
                    {errors?.companyInfo && (
                      <p className="text-red-500 text-sm mt-1">{errors?.companyInfo?.message}</p>
                    )}
                  </div>
                </div>


              </div>

              <div className='mt-6 mb-8'>
                <h2 className='text-gray-900 font-bold text-[20px]'>Address</h2>
                <div className="grid grid-cols-1 gap-4 mt-2">

                  <div className="form-group">
                    <label
                      htmlFor="username"
                      className="block text-[#374151] font-semibold text-sm font-Inter"
                    >
                      Street Address
                    </label>
                    <div className="input-group mb-3 mt-2">
                      <input
                        {...register("streetAddress")}
                        type="text"
                        placeholder="eg. Street 7"

                        className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                      />
                   
                    </div>
                  </div>


                </div>
                <div className="grid grid-cols-1 gap-4 mt-2">

                  <div className="form-group">
                    <label
                      htmlFor="username"
                      className="block text-[#374151] font-semibold text-sm"
                    >
                      Location
                    </label>
                    <div className="input-group mb-3 mt-2">
                      <input
                        {...register("apartment")}
                        type="text"
                        placeholder="Enter Location"

                        className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                      />
                      {/* {errors.firstName && (
                <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
              )} */}
                    </div>
                  </div>


                </div>
                <div className="grid grid-cols-2 gap-5">

                  <div className="form-group">
                    <label
                      htmlFor="username"
                      className="block text-[#374151] font-semibold text-sm"
                    >
                      Country
                    </label>
                    <div className="input-group mb-3 mt-2">
                      <select
                        value={selectedCountry || ""}
                        {...register("mtCountryDto")}
                        onChange={(e) => handleCountryChange(e)}
                        className={`border p-2 rounded-md mt-1 w-full`}
                      >
                        <option value="">Select country</option>
                        {mtContryData.map((item: any) => (
                          <option
                            key={item.id}
                            value={item.id !== null ? item.id : ""}
                          >
                            {item.name}
                          </option>
                        ))}
                      </select>
                      {/* {errors.firstName && (
              <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
            )} */}
                    </div>
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="username"
                      className="block text-[#374151] font-semibold text-sm"
                    >
                      State
                    </label>
                    <div className="input-group mb-3 mt-2">
                      <input
                        {...register("state", {
                          // required: 'Apartment is required',
                        })}
                        type="text"
                        placeholder="Enter state Name"

                        className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                      />
                    </div>
                  </div>

                </div>
                <div className="grid grid-cols-2 gap-5">

                  <div className="form-group">
                    <label
                      htmlFor="username"
                      className="block text-[#374151] font-semibold text-sm"
                    >
                      City
                    </label>
                    <div className="input-group mb-3 mt-2">
                      <input
                        {...register("city")}
                        type="text"
                        placeholder="Enter City Name"

                        className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                      />
                      {/* {errors.firstName && (
                <p className="text-red-500 text-sm mt-1">{errors.firstName.message}</p>
              )} */}
                    </div>
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="username"
                      className="block text-[#374151] font-semibold text-sm"
                    >
                      Postal Code
                    </label>
                    <div className="input-group mb-3 mt-2">
                      <input
                        {...register("postalCode")}
                        type="text"
                        placeholder="Enter Postal Code"

                        className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md focus:outline-none focus:border-red-500 focus:ring-1 focus:ring-red-500"
                      />
                      {/* {errors.lastName && (
                <p className="text-red-500 text-sm mt-1">{errors.lastName.message}</p>
              )} */}
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
          <div className='w-full bg-white px-8 pt-4 mt-5 pb-5'>
            <p className='font-bold text-2xl text-gray-900  border-b-gray-200'>Authors</p>
            <div className="form-group mb-10 mt-5 w-[80%] ">

              {events.map((event: any, index: number) => (
                <div className="mt-4 ">
                  {/* <> */}

                  <div className="mb-3 bg-white" key={event.id}>
                    <Accordion
                      key={event?.id}
                      expanded={expanded === `panel${event?.id}`}
                      onChange={handleChange(`panel${event?.id}`)}
                      className="accordion-root p-3"
                      style={{
                        boxShadow: "0px 4px 32px 0px #0000001A",
                      }}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${event?.id}-content`}
                        id={`panel${event?.id}-header`}
                        className="accordion-summary text-lg font-semibold"
                        style={{ backgroundColor: "white" }}
                      >
                        <Typography
                          className="text-lg font-semibold"
                          style={{ fontWeight: "600", fontSize: "18px" }}
                        >
                          {submittedData?.authorDtos?.[index]?.name?.trim()
                            ? submittedData.authorDtos[index].name
                            : `Author ${index + 1}`}

                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails className="accordion-details bg-white">
                        <Typography component={"div"}>
                          {/* Form details go here */}
                          <div className='flex items-center py-3'>
                            <img src={
                              files[index] &&
                                files[index] instanceof Blob
                                ? URL.createObjectURL(
                                  files[index] as Blob
                                ) // Type assertion here
                                : submittedData?.authorDtos?.[index]?.imageDto?.documentUrl || '/images/userImg.svg'
                            }
                              alt="Preview" className='w-[80px] h-[80px] mr-3 rounded-full' />
                            <div>
                              <p className="font-semibold text-gray-900 text-base font-sans">
                                Upload profile
                              </p>
                              <p className="text-sm font-normal text-gray-500 mt-2 font-sans mb-3">
                                Photo should be atleast in 150px X 150px
                              </p>

                              <label className=' mt-2 px-4 border border-[#D1D5DB] text-[#374151] font-medium text-sm rounded-md p-2 cursor-pointer'>
                                Upload new photo
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={(e) =>
                                    handleFileChanges(e, index)
                                  }
                                  className="hidden"
                                />
                              </label>
                            </div>
                          </div>
                          <div className="form-group mb-4 ">
                            <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                              Name
                            </label>
                            <div className="relative">
                              <input
                                type="text"
                                placeholder="Enter Name "
                                {...register(
                                  `authorDtos.${index}.name`
                                )}
                                className={`form-control mt-1 p-2 rounded w-full font-medium ${errors?.authorDtos?.[index]?.name
                                  ? "border border-[#B91C1C]"
                                  : "border border-gray-300"
                                  }`}
                                style={{
                                  outline: errors?.authorDtos?.[index]
                                    ?.name
                                    ? "2px solid red"
                                    : "none",
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group mb-4 ">
                            <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                              Author Bio
                            </label>
                            <div className="relative">
                              <textarea
                                rows={6}
                                placeholder="Enter Author Bio"
                                {...register(
                                  `authorDtos.${index}.bio`,
                                  {
                                    maxLength: {
                                      value: 500,
                                      message: "Bio must be at most 500 characters",
                                    },
                                  }

                                )}
                                className="w-full border p-2 rounded-md"
                              />
                              {errors?.authorDtos?.[index]?.bio && (
                                <p className="text-red-500 text-sm mt-1">{errors?.authorDtos[index]?.bio?.message}</p>
                              )}
                            </div>
                          </div>
                          <div className="grid grid-cols-2 gap-4">
                            <div className=" form-group mb-4 ">
                              <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                Email
                              </label>
                              <div className="relative">
                                <input
                                  type="email"
                                  placeholder="Enter Email "
                                  {...register(
                                    `authorDtos.${index}.email`
                                  )}
                                  className={`form-control mt-1 p-2 rounded w-full font-medium`}
                                />
                              </div>
                            </div>

                            <div className="form-group mb-4 ">
                              <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                Contact Number
                              </label>
                              <div className="flex border border-gray-300 rounded mt-1 form-controls">
                                <select
                                  value={phoneCode.isoCode || ""}
                                  {...register(`authorDtos.${index}.phoneisoCode`)}
                                  onInput={(e) => {
                                    e.currentTarget.value = e.currentTarget.value.replace(/[^0-9]/g, "");
                                  }}
                                  onChange={(e) => phoneNuberChange(e)}
                                  className="border-none bg-white pl-3 py-2 text-sm font-semibold text-gray-700 focus:outline-none"
                                >
                                  {mtContryData.map((item: any) => (
                                    <option key={item.id} value={item.isoCode || ""}>
                                      {item.isoCode}
                                    </option>
                                  ))}
                                </select>
                                <input
                                  type="text"
                                  placeholder="Enter your Contact number"
                                  {...register(
                                    `authorDtos.${index}.contactNo`
                                  )}
                                  className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-group mb-4 ">
                            <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                              Address
                            </label>
                            <div className="relative">
                              <textarea
                                rows={6}
                                placeholder="Enter Address"
                                {...register(
                                  `authorDtos.${index}.address`
                                )}
                                className="w-full border p-2 rounded-md"
                              />
                            </div>
                          </div>
                        </Typography>
                      </AccordionDetails>
                    </Accordion>
                  </div>

                  {/* </> */}
                </div>
              ))}

              {/* {events.length <= 0 && ( */}
              <div
                onClick={handleAddEvent}
                className="mt-4 p-2 w-[12rem] h-10 cursor-pointer bg-[#FFFFFF] text-gray-700 font-semibold rounded border border-gray-300"
              >
                {events.length === 0 ? "+ Add Author Details" : "+ Add another Author"}
              </div>
              {/* )} */}

            </div>
          </div>
        </div>
        <div className="px-4 flex justify-end  p-4 items-center  bg-white"
          style={{
            boxShadow: "0px -16px 50px 0px #0000000D",
          }}>
          <div></div>
          <div>

          <button
            type="submit"
            className="border border-gray-300 px-4 py-2 rounded-md text-sm text-gray-700 mr-2"
            onClick={draft} 
          >
       Save as draft
          </button>
                 </div>
        <div>
       
          <button
            type="submit"
            className="px-7 py-2 gradient-background font-Inter text-white rounded font-bold text-base"
            onClick={approve}
          >
         Approve & Publish Profile
          </button>
          </div>
        </div>
      </form>
      {showConfirmation &&
  <DynamicTextPopup onClose={handleClosePopup} title={isApprove ? 'Confirm Approval & Publish ' :'Confirm Save as draft'}   body={isApprove ? 'Are you sure you want to approve and publish this profile? Once published, the profile will be visible to the public. ' : ' Your company profile details will be saved as a draft. You can edit and submit for approval later.'} confirmButtonName={isApprove ? 'Approve & Publish' :'Yes, Save as Draft'} closeButtonName='Cancel'
  onConfirm={saveData} />
}
{isOpen &&
   <DynamicSuccessPopup
   onClose={closePopup}
   title={!isApprove ? 'Draft Saved Successfully!' : 'Profile Published Successfuly!'}
   body={!isApprove ? 'Your company profile has been saved as a draft. You can edit and submit it for approval anytime.' :'The profile has been approved and published. It is now live and visible to the public.'}
   closeButtonName="Okay"
 />
}
    </div>

  )
}


export default CompanyProfile
